import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'survey/:survey_id/debug',
    loadComponent: () => import('./pages/survey/survey').then(m => m.Survey)
  },
  {
    path: 'survey/:assignment_id',
    loadComponent: () => import('./pages/survey/survey').then(m => m.Survey)
  },
  {
    path: '',
    redirectTo: 'survey/demo',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'survey/demo'
  }
];